import React from "react";
import "./index.scss";

const index = ({ control, text, type, theme }) => {
  let title = "";

  switch (type) {
    case "SECTION":
      title = <h2 className={`section section-title-${theme}`}>{text}</h2>;
      break;
    case "SUB-SECTION":
      title = (
        <h3 className={`sub-section sub-section-title-${theme} ${control}`}>
          {text}
        </h3>
      );
      break;
    case "CARD-COMPACT-TITLE":
      title = <h3 className={`card-compact card-title-${theme}`}>{text}</h3>;
      break;
    case "CARD-COMPACT-SUBTITLE":
      title = <h5 className={`card-compact card-subtitle-${theme}`}>{text}</h5>;
      break;
    case "CARD-EXPANDED-TITLE":
      title = <h3 className={`card-expanded card-title-${theme}`}>{text}</h3>;
      break;
    case "CARD-EXPANDED-TITLE-ALT":
      title = <h4 className={`card-expanded card-title-${theme}`}>{text}</h4>;
      break;
    case "CARD-EXPANDED-SUBTITLE":
      title = (
        <h5 className={`card-expanded card-subtitle-${theme}`}>{text}</h5>
      );
      break;
    default:
      break;
  }

  return title;
};

export default index;
